import type { Route } from "./+types/check-in.layout.tsx"

import { Res } from "@iyk/vf-server"
import { Effect, Option } from "effect"
import { preload } from "react-dom"
import { Outlet } from "react-router"
import { appConfig } from "../app-config.ts"
import { Handler } from "../server/handler.ts"
import { FanLayout } from "../ui/fan-layout.tsx"

export const meta = () => {
  return [
    { title: `Check In | ${appConfig.artist.name}` },
    { property: "og:title", content: `Check In | ${appConfig.artist.name}` },
    { name: "description", content: appConfig.meta.description }
  ]
}

export const loader = Handler.make("check-in-confirmation", ({ shows }) =>
  Effect.gen(function* () {
    const show = yield* shows.findLive.pipe(Effect.option)

    return Res.json({
      showImageUrl: Option.isNone(show) ? null : show.value.value.image.href
    })
  })
)

export const clientLoader = async ({ serverLoader }: Route.ClientLoaderArgs) => {
  const serverData = await serverLoader()

  preload(appConfig.assets.images.background, { as: "image" })

  if (serverData.showImageUrl) {
    preload(serverData.showImageUrl, { as: "image" })
  }

  return null
}

export default function CheckInLayout() {
  return (
    <FanLayout>
      <Outlet />
    </FanLayout>
  )
}
